(function () {
    // Used in challenge_detail.jsp
    window.getCsrfTokenOrNull = function () {
        const cookieToken = readCookie(csrfTokenCookieName);
        if (cookieToken != null && cookieToken !== 'undefined') {
            return cookieToken;
        }
        return null;
    };

    // Used in redeemGiftCertificateBranded.js
    window.isDcUrl = function (url) {
        // If the URL contains donorschoose.org or if it's a relative URL we assume the request is going to our servers.
        // We don't want to send our CSRF token to other sites.
        // At best that's unnecessary and at worst it might enable some CSRF exploit.
        return /.*donorschoose\.org.*/.test(url) || !/^http/.test(url);
    };

    const csrfMethods = /(PUT|POST|DELETE)/i;

    // Add CSRF token header to all relevant AJAX calls made with jQuery
    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        const token = window.getCsrfTokenOrNull();
        if (token != null) {
            if (csrfMethods.test(options.method || options.type) && window.isDcUrl(options.url)) {
                jqXHR.setRequestHeader(csrfTokenHeaderName, token);
            }
        }
    });

    // Add CSRF field to forms before submission
    $(document).on('submit', 'form', function (evt) {
        const token = window.getCsrfTokenOrNull();
        if (token != null) {
            const form = evt.target;
            const tokenInput = '<input type="hidden" name="_csrf" value="' + token + '" />';
            if (csrfMethods.test(form.method) && window.isDcUrl(form.action)) {
                if (form.enctype === 'multipart/form-data') {
                    const actionUrl = new URL(form.action);
                    actionUrl.searchParams.append('_csrf', token);
                    form.action = actionUrl.toString();
                } else {
                    $(form).not(':has(input[name=_csrf])').append(tokenInput);
                }
            }
        }
    });
})();
